/**
 * created by tian ruo jun
 网站稿件基本信息（重要性、点击数等）
 *
 */
import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {Button, DatePicker, Icon, Input, InputNumber, Radio, Select, message} from "antd";
import moment from 'moment';

const {Option} = Select;
const { RangePicker } = DatePicker;
const publishSettings = {
//栏目信息
    programaKey: 'programaFtitle',//栏目信息数据保存标题key
    programaName: '栏目',//栏目信息标题名称
//当前栏目信息
    currentColumnKey: 'currentColumnFtitle',//当前栏目信息数据保存标题key
    currentColumnName: '当前栏目',//当前栏目信息标题名称
    headlinesPlaceholder: '这是一个栏目名称',//栏目名称的提示
    currentColumnIsRequest: true,//是否必输项，
    currentColumnCheckMessage: '请选择当前栏目',
//重要性数据
    numericalKey: 'numericalFtitle',//重要性数据保存标题key
    numericalName: '重要性',//重要性信息标题名称
    numericalhint: '数值越小越重要',//重要性提示
    numericalPlaceholder: '请输入重要性',//重要性的提示
    numericalIsRequest: true,//是否必输项，
    numericalCheckMessage: '请输入重要性',
//显示位置
    locationKey: 'locationFtitle',//显示位置数据保存标题key
    locationName: '显示位置',//显示位置信息标题名称
    locationPlaceholder: '请选择显示位置',//显示位置的提示
    //点击次数
    frequencyKey: 'frequencyFtitle',//点击次数数据保存标题key
    frequencyName: '点击次数',//点击次数信息标题名称
    frequencyPlaceholder: '请输入点击次数',//点击次数的提示
    frequencyIsRequest: true,//是否必输项，
    frequencyCheckMessage: '请输入点击次数',
};
export default class OtherAttributes extends Component {
    static defaultProps = {};
    static propTypes = {};

    constructor(props) {
        super(props);
        this.state = {
            meanWhile: false,
            synchronize: true,
            contribute:true,
            properties: true,
            orso: true,
            switchShow: false,
            publishInformation: {
                // 发布时间
                "newdate": "",
                // 下线时间
                "wbenddate": "",
                // 重要性 int
                "wbweight": 10,
                // 是否头条 int
                "wbfirst": 0,
                // 头条结束时间
                "wbfirstenddate": "",
                // 头条开始时间
                "wbfirststartdate": "",
                // 是否置顶 int
                "wbtop": 0,
                // 置顶开始时间
                "wbtopdate": "",
                // 置顶结束时间
                "wbgotopdate": "",
                // 是否推荐 int
                "wbrecommend": 0,
                // 点击量 int
                "wbshowtimes": 0,
            }
        }
    }

    componentWillMount() {
    }

    componentDidMount() {
    }

    getData=()=> {
      return this.state.publishInformation
    };

    setData =(data) => {
        this.state.publishInformation = {
            ...this.state.publishInformation,
            ...data,
        };
        this.setState({});
    };

    render() {
        const {publishInformation, properties} = this.state;
        publishInformation.wbfirst =  this.setSelected(publishInformation.wbfirst); // 设置默认值0
        publishInformation.wbtop =  this.setSelected(publishInformation.wbtop); // 设置默认值0
        publishInformation.wbrecommend =  this.setSelected(publishInformation.wbrecommend); // 设置默认值0
        let wbfirststartdate = publishInformation["wbfirststartdate"] ? moment(publishInformation["wbfirststartdate"]) : null;
        let wbfirstenddate = publishInformation["wbfirstenddate"] ? moment(publishInformation["wbfirstenddate"]) : null;
        let wbtopdate = publishInformation["wbtopdate"] ? moment(publishInformation["wbtopdate"]) : null;
        let wbgotopdate = publishInformation["wbgotopdate"] ? moment(publishInformation["wbgotopdate"]) : null;
        if(!this.state.publishInformation['newdate']) {
            // 当前时间为默认发布时间
            this.state.publishInformation['newdate'] = Date.now();
        }
        if(publishInformation['wbenddate'] && publishInformation['wbenddate']<=this.state.publishInformation['newdate']) {
            // 重置下线时间
            publishInformation['wbenddate'] = null
        }
        return (
            <>
                <div className="otherAttributes">
                    <div className="overstriking">其他属性</div>
                    <div><Icon className="lineIcon" type={properties ? "down" : "up"}
                               onClick={this.propertiesInfor}/>
                    </div>
                </div>
                {properties ?
                    <div>
                        <div className="elseRelease">
                            <div className="unifiedStyle">发布时间</div>
                            <DatePicker
                                showTime
                                allowClear={false}
                                value={publishInformation['newdate']?moment(publishInformation['newdate']):null}
                                onChange={(value,b)=>{
                                    this.onChange({
                                        value: value?value.valueOf():null,
                                        key: 'newdate'
                                    })
                                }}
                                className="elseReleaseTime"
                            />
                        </div>
                        <div className="tapeOut">
                            <div className="unifiedStyle">下线时间</div>
                            <DatePicker
                                showTime
                                // allowClear={false}
                                disabledTime={(current)=>this.disabledDateTime(current, "newdate")}
                                disabledDate={(current)=>this.disabledPriceRangeDate(current,"newdate")}
                                value={publishInformation['wbenddate']?moment(publishInformation['wbenddate']):null}
                                onChange={(value,b)=>{
                                    let publishTime = this.state.publishInformation['newdate'];
                                    let newTime = null;
                                    if(value && value.valueOf()){
                                        newTime = value.valueOf()
                                    }
                                    if(publishTime && newTime && publishTime > newTime) {
                                        let endDay = moment(newTime).endOf("day").valueOf();
                                        if(publishTime < endDay) {
                                            newTime = endDay
                                        } else {
                                            message.error("下线时间不能早于发布时间");
                                            return false
                                        }
                                    }
                                    this.onChange({
                                        value: newTime ? newTime : null,
                                        key: 'wbenddate'
                                    })
                                }}
                                className="elseReleaseTime"
                            />
                        </div>
                        {/* <div className="elseRelease">
                            <div className="significance">
                                <div>{publishSettings.numericalName}</div>
                                <div className="importanceValue">{publishSettings.numericalhint}</div>
                            </div>
                            <InputNumber
                                className="elseReleaseTime"
                                min={1} max={99999}
                                placeholder={publishSettings.numericalPlaceholder}
                                value={publishInformation.wbweight ? publishInformation.wbweight * 1 : 10}
                                onChange={(num) => {
                                    this.onChange({
                                        value: num,
                                        key: 'wbweight'
                                    })
                                }}/>
                        </div> */}

                        <div className="tapeOut">
                            <div className="unifiedStyle">设置置顶</div>
                            <Radio.Group
                                className="elseReleaseTime"
                                onChange={e => {
                                    this.onChange({
                                        value: e.target.value*1,
                                        key: 'wbtop'
                                    });
                                    this.onRangePickerChange({
                                        value:'',
                                        startKey:'wbtopdate'
                                    });
                                    this.onRangePickerChange({
                                        value:'',
                                        endKey:'wbgotopdate'
                                    })
                                }}
                                value={publishInformation.wbtop}
                            >
                                <Radio value={1}>是</Radio>
                                <Radio value={0}>否</Radio>
                            </Radio.Group>
                        </div>
                        {
                            publishInformation.wbtop == 1 ? (
                                <div className="tapeOut">
                                    <div className="unifiedStyle">设置置顶时间</div>
                                    <DatePicker showTime placeholder="开始时间"
                                                className="elseReleaseTime"
                                        // allowClear={false}
                                                value={wbtopdate}
                                                onChange={(value, dateString)=>{
                                                    let endTime = this.state.publishInformation.wbgotopdate;
                                                    if(endTime && value && value.valueOf() > endTime){
                                                        message.destroy();
                                                        message.error("开始时间不能大于结束时间！");
                                                        return;
                                                    }
                                                    this.onRangePickerChange({
                                                        value, dateString,
                                                        startKey:'wbtopdate'
                                                    })
                                                }}
                                                onOk={(value)=>{
                                                    this.onRangePickerChange({
                                                        value,
                                                        startKey:'wbtopdate'
                                                    })
                                                }}
                                    />
                                    <DatePicker showTime placeholder="结束时间"
                                                className="elseReleaseTime"
                                        // allowClear={false}
                                                value={wbgotopdate}
                                                disabledTime={(current)=>this.disabledDateTime(current, "wbtopdate")}
                                                disabledDate={(current)=>this.disabledPriceRangeDate(current,"wbtopdate")}
                                                onChange={(value, dateString)=>{
                                                    let startTime = this.state.publishInformation.wbtopdate;
                                                    let newTime = null
                                                    if(value && value.valueOf()){
                                                        newTime = value.valueOf()
                                                    }
                                                    if(startTime && newTime && startTime > newTime){
                                                        let endDay = moment(newTime).endOf("day").valueOf();
                                                        if(startTime < endDay) {
                                                            newTime = endDay
                                                        } else {
                                                            message.error("下线时间不能早于发布时间");
                                                            return false
                                                        }
                                                    }
                                                    this.onRangePickerChange({
                                                        value:newTime, dateString,
                                                        endKey:'wbgotopdate'
                                                    })
                                                }}
                                                onOk={(newTime)=>{
                                                    this.onRangePickerChange({
                                                        value:newTime,
                                                        endKey:'wbgotopdate'
                                                    })
                                                }}
                                    />

                                </div>
                            ) : null
                        }

                        <div className="tapeOut">
                            <div className="unifiedStyle">设置头条</div>
                            <Radio.Group
                                className="elseReleaseTime"
                                onChange={e =>{
                                    this.onChange({
                                        value: e.target.value*1,
                                        key: 'wbfirst'
                                    });
                                    this.onRangePickerChange({
                                        value:'',
                                        startKey:'wbfirststartdate'
                                    });
                                    this.onRangePickerChange({
                                        value:"",
                                        endKey:'wbfirstenddate',
                                    })
                                }}
                                value={publishInformation.wbfirst}
                            >
                                <Radio value={1}>是</Radio>
                                <Radio value={0}>否</Radio>
                            </Radio.Group>
                        </div>
                        {
                            publishInformation.wbfirst == 1 ? (
                                <div className="tapeOut">
                                    <div className="unifiedStyle">设置头条时间</div>
                                    <DatePicker showTime placeholder="开始时间"
                                                className="elseReleaseTime"
                                                // allowClear={false}
                                                value={wbfirststartdate}
                                                onChange={(value, dateString)=>{
                                                    let endTime = this.state.publishInformation.wbfirstenddate;
                                                    if(endTime && value && value.valueOf() > endTime){
                                                        message.destroy();
                                                        message.error("开始时间不能大于结束时间！");
                                                        return;
                                                    }
                                                    this.onRangePickerChange({
                                                        value, dateString,
                                                        startKey:'wbfirststartdate'
                                                    })
                                                }}
                                                // onOk={(value)=>{
                                                //     this.onRangePickerChange({
                                                //         value,
                                                //         startKey:'wbfirststartdate'
                                                //     })
                                                // }}
                                    />
                                    <DatePicker showTime placeholder="结束时间"
                                                className="elseReleaseTime"
                                                // allowClear={false}
                                                value={wbfirstenddate}
                                                disabledTime={(current)=>this.disabledDateTime(current, "wbfirststartdate")}
                                                disabledDate={(current)=>this.disabledPriceRangeDate(current,"wbfirststartdate")}
                                                onChange={(value, dateString)=>{
                                                    let startTime = this.state.publishInformation.wbfirststartdate;
                                                    let newTime = null;
                                                    if(value && value.valueOf()){
                                                        newTime = value.valueOf()
                                                    }
                                                    if(startTime && newTime && startTime > newTime){
                                                        let endDay = moment(newTime).endOf("day").valueOf();
                                                        if(startTime < endDay) {
                                                            newTime = endDay
                                                        } else {
                                                            message.destroy();
                                                            message.error("下线时间不能早于发布时间");
                                                            return false
                                                        }
                                                    }
                                                    this.onRangePickerChange({
                                                        value:newTime, dateString,
                                                        endKey:'wbfirstenddate',
                                                    })
                                                }}
                                                // onOk={(newTime)=>{
                                                //     this.onRangePickerChange({
                                                //         value:newTime,
                                                //         endKey:'wbfirstenddate'
                                                //     })
                                                // }}
                                    />
                                </div>
                            ) : null
                        }

                        <div className="tapeOut">
                            <div className="unifiedStyle">设置推荐</div>
                            <Radio.Group
                                className="elseReleaseTime"
                                onChange={e =>
                                    this.onChange({
                                        value: e.target.value*1,
                                        key: 'wbrecommend'
                                    })
                                }
                                value={publishInformation.wbrecommend}
                            >
                                <Radio value={1}>是</Radio>
                                <Radio value={0}>否</Radio>
                            </Radio.Group>
                        </div>
                        {/*显示位置？*/}
                        {/*<div className="tapeOut">*/}
                        {/*    <div className="unifiedStyle">{publishSettings.locationName}</div>*/}
                        {/*    <Select className="elseReleaseTime" placeholder={publishSettings.locationPlaceholder}*/}
                        {/*            value={publishInformation.location ? publishInformation.location : undefined}*/}
                        {/*            onChange={this.selectValue}>*/}
                        {/*        <Option value="jack">Jack</Option>*/}
                        {/*        <Option value="lucy">Lucy</Option>*/}
                        {/*        <Option value="Yiminghe">yiminghe</Option>*/}
                        {/*    </Select>*/}
                        {/*</div>*/}

                        <div className="tapeOut">
                            <div>{publishSettings.frequencyName}</div>
                            <Input
                                className="elseReleaseTime"
                                onChange={(e) => {
                                    let wbshowtimes = 0;
                                    if(e.target.value) {
                                        wbshowtimes = e.target.value;
                                        wbshowtimes = wbshowtimes.replace(/[^[0-9]]*/,"");// 去除非数字
                                        wbshowtimes = wbshowtimes.replace(/^[0]([0]+)/,"");// 去除连续0
                                        wbshowtimes = wbshowtimes.replace(/^([0])([1-9]+)/,"$2");// 去除首个0
                                        if(parseInt(wbshowtimes) > 100000000){
                                            // message.warn("请输入正确的点击次数（0-100,000,000）！");
                                            return;
                                        }
                                    }
                                    this.onChange({
                                        value: wbshowtimes*1,
                                        key: 'wbshowtimes'
                                    })
                                }}
                                value={publishInformation.wbshowtimes || 0}
                                placeholder={publishSettings.frequencyPlaceholder}
                            ></Input>
                        </div>
                    </div> : ''
                }
            </>
        )
    };

    range = (start, end) => {
        const result = [];
        for (let i = start; i < end; i++) {
            result.push(i);
        }
        return result;
    };

    // 时间选择器禁用规范(返回需要禁用的区域)
    disabledDateTime = (current,key) => {
        let publishTime = this.state.publishInformation[key];
        let thisDateOf0 = moment(current).startOf("day").format('x');
        console.log("当前时间是：",moment(current).format("YYYY-MM-DD HH-mm-ss"));
        if (publishTime && publishTime > thisDateOf0) {
            const diffDuration = moment(current);
            const hours = diffDuration.hours();
            const minutes = diffDuration.minutes();
            const seconds = diffDuration.seconds();
            const publishDiffDuration = moment(publishTime);
            let publishHours = publishDiffDuration.hours();
            let publishMinutes = 0;
            let publishSeconds = 0;
            if (hours <= publishHours) {
                publishMinutes = publishDiffDuration.minutes();
                if (minutes <= publishMinutes) {
                    publishSeconds = publishDiffDuration.seconds() * 1 + 1;
                }
            }
            return {
                disabledHours: () => this.range(0, 24).splice(0, publishHours),
                disabledMinutes: () => this.range(0, 60).splice(0, publishMinutes),
                disabledSeconds: () => this.range(0, 60).splice(0, publishSeconds),
            };
        }
        return {};
    };

    // 日期选择器禁用规范(返回需要禁用的区域)
    disabledPriceRangeDate = (current, key) => {
        let publishTime = this.state.publishInformation[key];
        let newDate = Date.now();
        let thisDay = moment(current).endOf("day").format('x') * 1;
        let thisPublishTime = moment(publishTime).format('x') * 1 + 1000;
        // console.log("thisday",thisDay);
        // console.log("publishTime",thisPublishTime);
        if (publishTime && publishTime >= newDate) {
            return thisDay <= thisPublishTime;
        } else {
            return thisDay < newDate;
        }
        return null
    };

    propertiesInfor = () => {
        const {properties} = this.state;
        this.setState({
            properties: !properties,
        })
    };

    onChange = ({value,key}) => {
        this.state.publishInformation[key] = value;
        this.setState({})
    };

    onRangePickerChange({value, dateString, startKey, endKey}) {
        console.log('Selected Time: ', value);
        console.log('Formatted Selected Time: ', dateString);
        let startTime = '';
        let endTime = '';
        if(value){
            startTime = value.valueOf();
            endTime = value.valueOf();
        }
        this.state.publishInformation[startKey] = startTime;
        this.state.publishInformation[endKey] = endTime;
        this.setState({})
    };

    setSelected = (num) => {
        if(num!==1) {
            return 0
        } else {
            return num
        }
    };

}